import {StrictMode} from 'react'
import {createRoot} from 'react-dom/client'
import {LogtoProvider} from '@logto/react'
import App from './App.jsx'

import {PostHogProvider} from 'posthog-js/react'

const options = {
    api_host: import.meta.env.VITE_PUBLIC_POSTHOG_HOST,
    defaults: '2025-05-24',
    cookieless_mode: 'on_reject',
    before_send: (event) => {
        // Only send events if user has opted in to tracking
        const trackingEnabled = localStorage.getItem('posthog_tracking_enabled');
        return trackingEnabled === 'true' ? event : null;
    },
}

//import './styles/gamification.css'

// Logto Configuration
const endpoint = import.meta.env.VITE_LOGTO_ENDPOINT;
const appId = import.meta.env.VITE_LOGTO_APP_ID;

// Loading the scopes from the environment variable
let scopes = [];
try {
    const scopesString = import.meta.env.VITE_LOGTO_SCOPES;
    scopes = JSON.parse(scopesString.replace(/'/g, '"'));
} catch (error) {
    console.error('Error parsing scopes:', error);
    // Fallback to default scopes
    scopes = ['openid', 'profile', 'email', 'self', 'student', 'teacher', 'admin'];
}

const allScopes = [
    ...scopes,
    'roles'
];

const logtoConfig = {
    appId,
    endpoint,
    scopes: allScopes,
    resources: [import.meta.env.VITE_LOGTO_RESOURCES],
};

createRoot(document.getElementById('root')).render(
    <StrictMode>
        <PostHogProvider apiKey={import.meta.env.VITE_PUBLIC_POSTHOG_KEY} options={options}>
            <LogtoProvider config={logtoConfig}>
                <App/>
            </LogtoProvider>
        </PostHogProvider>
    </StrictMode>,
)